import { render, staticRenderFns } from "./ContestApply.vue?vue&type=template&id=0480897a&scoped=true"
import script from "./ContestApply.vue?vue&type=script&lang=js"
export * from "./ContestApply.vue?vue&type=script&lang=js"
import style0 from "./ContestApply.vue?vue&type=style&index=0&id=0480897a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480897a",
  null
  
)

export default component.exports